import PolarisIcon from '@/components/_common/PolarisIcon';
import styled from '@emotion/styled';
import { Grid } from '@mui/material';
import { SyntheticEvent } from 'react';
import Autocomplete, { AutocompleteProps } from '../../_common/Form/Autocomplete';

type ProfileSelectionFieldProps = {
  value: any;
  options: any[];
  onChange: (event: SyntheticEvent, value: any) => void;
  error?: boolean;
  innerRef?: any;
} & AutocompleteProps;

const ProfileSelectionField = ({ value, options = [], onChange, error, innerRef, ...props }: ProfileSelectionFieldProps) => {
  return (
    <Autocomplete
      id="profile"
      label="Profile"
      data-testid="profile-select"
      innerRef={innerRef}
      required
      options={options}
      value={value}
      placeholder="Start typing to search"
      renderOption={(props: any, option: any) => <CustomLocationOption {...props} {...option} />}
      isOptionEqualToValue={(option: any, value: any) => option?.id == value?.id}
      onChange={onChange}
      noOptionsText="No profiles found for selected customer."
      error={error}
      blurOnSelect
      {...props}
    />
  );
};

export default ProfileSelectionField;

const CustomLocationOption = (props: any) => {
  const type = props.data?.workflow_type || 'version_based';

  return (
    <Grid container alignItems="center" flexWrap="nowrap" {...props}>
      <Grid item>{props.label}</Grid>
      <Grid item sx={{ ml: 'auto', lineHeight: 1, height: 30, display: 'inline-flex', alignItems: 'center' }}>
        <StyledIcon type={type} width={24} icon={type} />
      </Grid>
    </Grid>
  );
};

type StyledIconProps = {
  type: string;
};
const StyledIcon = styled(PolarisIcon)<StyledIconProps>`
  color: ${({ theme, type }) => {
    if (type === 'component_based' || type === 'component_based_bundle') return theme.palette.lavender.main;
    else if (type === 'version_based' || type === 'version_based_bundle' || type === 'package') return theme.palette.teal.main;
    else if (type === 'bulk') return theme.palette.secondary.main;
    else return theme.palette.info.main;
  }};
`;
